import { type KeyboardEvent, useCallback } from 'react'
import { type Observable } from 'rxjs'
import { type SelectOption } from '@/components/inputs/select-option'
import { ToggleGroup, ToggleItem } from '@/components/ToggleGroup'

export interface SimpleSelectProps {
  multi: boolean
  options: SelectOption[]
  selectedIds: string[]
  isDisabled: boolean
  onToggleOption: (option: SelectOption) => unknown
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
  /**
   * Prefix of the options' test IDs, which end in the option ID.
   */
  optionTestIdPrefix?: string
}

export function SimpleSelect({
  multi,
  options,
  selectedIds,
  isDisabled,
  onToggleOption,
  onEnterDown,
  focus$,
  onFocus,
  isNotValid,
  optionTestIdPrefix,
}: SimpleSelectProps) {
  const keyDown = useCallback(
    (e: KeyboardEvent) => e.key === 'Enter' && onEnterDown?.(e),
    [onEnterDown],
  )

  return (
    <ToggleGroup stretch multi={multi} focus$={focus$} onFocus={onFocus}>
      {options.map((option) => (
        <ToggleItem
          toggled={selectedIds.includes(option.id)}
          isDisabled={isDisabled}
          title={option.text}
          onChange={() => onToggleOption(option)}
          key={option.id}
          onKeyDown={keyDown}
          isNotValid={isNotValid}
          testId={
            optionTestIdPrefix
              ? `${optionTestIdPrefix}-${option.id}`
              : undefined
          }
        >
          {option.text}
        </ToggleItem>
      ))}
    </ToggleGroup>
  )
}
